import type { Bolt_On_Discharges } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export type BoltOnDischargeRowData = Bolt_On_Discharges;

const customerFlagColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  }
];

const identityColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] = [
  {
    editable: true,
    sortable: true,
    field: "manufacturer",
    header: "Manufacturer",
    searchable: true
  },
  {
    editable: true,
    sortable: true,
    field: "series_model",
    header: "Discharge Series / Model",
    searchable: true
  }
];

const sharedDimensionColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] = [
  {
    editable: true,
    sortable: true,
    field: "inner_diameter_inches",
    header: "Inner Diameter (in)",
    isNumber: true,
    nullable: true,
    searchable: true,
    decimalPlaces: 6
  }
];

const sizeColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] = [
  {
    editable: true,
    sortable: true,
    field: "length_inches",
    header: "Length (in)",
    isNumber: true,
    nullable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    sortable: true,
    field: "weight_pounds",
    header: "Weight (lbs)",
    isNumber: true,
    nullable: true,
    searchable: true,
    decimalPlaces: 6
  }
];

export const boltOnDischargeTableColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] =
  [
    ...customerFlagColumns,
    ...identityColumns,
    {
      editable: true,
      sortable: true,
      field: "tubing_diameter_inches",
      header: "Tubing Diameter (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6
    },
    {
      editable: true,
      sortable: true,
      field: "outer_diameter_inches",
      header: "Outer Diameter (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6
    },
    ...sharedDimensionColumns,
    {
      editable: true,
      sortable: true,
      field: "flange_outer_diameter_inches",
      header: "Flange Outer Diameter (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6
    },
    ...sizeColumns
  ];

export const hpsBoltOnDischargeTableColumns: EquipmentTableColumn<BoltOnDischargeRowData>[] =
  [
    ...customerFlagColumns,
    ...identityColumns,
    {
      editable: true,
      sortable: true,
      field: "outer_diameter_inches",
      header: "Primary OD (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6
    },
    ...sharedDimensionColumns,
    {
      editable: true,
      sortable: true,
      field: "neck_outer_diameter_inches",
      header: "Secondary OD (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6,
      adminOnly: true
    },
    {
      editable: true,
      sortable: true,
      field: "neck_inner_diameter_inches",
      header: "Tertiary OD (in)",
      isNumber: true,
      nullable: true,
      searchable: true,
      decimalPlaces: 6,
      adminOnly: true
    },
    ...sizeColumns
  ];
